export function validatePhone(phone: string): boolean {
  const regex = /^\d{10}$/;
  return regex.test(phone);
}